import axios, { getAuthHeaders, getFormDataHeaders } from "./config";

export default {
    all: function() {
        return axios.get("/profiles", {
            headers: getAuthHeaders(),
        });
    },

    store: function(profile) {
        return axios.post("/profiles", profile, {
            headers: getFormDataHeaders(),
        });
    },
    show: function(profileID) {
        return axios.get(`/profiles/${profileID}`, {
            headers: getAuthHeaders()
        })
    },

    update: function(data) {
        return axios.put(`/profiles/${data.id}`, data, {
            headers: getAuthHeaders(),
        });
    },

    delete: function(profileID) {
        return axios.delete(`/profiles/${profileID}`, {
            headers: getAuthHeaders(),
        });
    },
};